import { deleteRequest, getRequest, postRequest, putRequest } from '../services/http';

import type { dataOptions } from './types/data';

export const retreiveUserAddresses = async () => {
  const response = await getRequest({
    url: 'auth/user/addresses/',
    protected: true,
  });
  return response;
};

export const setPrimaryAddress = async (data: dataOptions) => {
  const response = await postRequest({
    url: `auth/user/addresses/${data.id}/make-primary/`,
    protected: true,
  });
  return response;
};

export const createAddress = async (data: dataOptions) => {
  const response = await postRequest({
    url: 'auth/user/addresses/',
    protected: true,
    data: data.params,
  });
  return response;
};

export const editAddress = async (data: dataOptions) => {
  const response = await putRequest({
    url: 'auth/user/addresses/',
    protected: true,
    data: data.params,
  });
  return response;
};

export const deleteAddress = async (data: dataOptions) => {
  const response = await deleteRequest({
    url: `addresses/${data.id}/`,
    protected: true,
  });
  return response;
};



import axios from 'axios';

export const searchAddressMapbox = async (query: string) => {
  const token = process.env.NEXT_PUBLIC_MAPBOX_TOKEN;
  const url = `https://api.mapbox.com/geocoding/v5/mapbox.places/${encodeURIComponent(query)}.json?access_token=${token}&autocomplete=true&types=address&limit=5&country=us`;
  
  const response = await axios.get(url);
  return response.data.features;
};

export const searchAddress = async (data: dataOptions) => {
  const response = await getRequest({
    url: `addresses/autocomplete_address/?query=${data.query}`,
    protected: true,
  });
  return response;
};

